(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@grapecity/inputman.comment"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["@grapecity/inputman.comment", "react"], factory);
	else if(typeof exports === 'object')
		exports["InputManReact"] = factory(require("@grapecity/inputman.comment"), require("react"));
	else
		root["InputManReact"] = factory(root["GC"], root["react"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__32__, __WEBPACK_EXTERNAL_MODULE__155__) => {
return 